import { AgentPriceCard as AgentPriceCardType } from '@/schemas/sceneDataSchema';
import { Stack, Typography } from '@mui/material';

export const AgentPriceCard = ({ component }: { component: AgentPriceCardType }) => {
  return (
    <Stack spacing={0}>
      <Typography variant='h2'>Agent Price Card</Typography>
      <Typography>Price Estimate Modal ID: {component.price_estimate_modal_id}</Typography>
      <Typography>Payment Details Modal ID: {component.payment_details_modal_id}</Typography>
    </Stack>
  );
};
